import "../../shimmer.css";
import CBELogo from "../../assets/CBE.png";

// Generic iOS-style frosted alert modal.
// Props: title, message, buttonLabel (default "Got it"), onClose
const AlertModal = ({ title, message, buttonLabel = "Got it", onClose }) => {
  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[200] flex items-center justify-center px-6"
    >
      <div
        onClick={onClose}
        className="absolute inset-0 bg-black/30 backdrop-blur-sm animate-sheet-fade"
      />
      <div className="relative w-full max-w-[330px] overflow-hidden rounded-[30px] bg-white/90 backdrop-blur-xl backdrop-saturate-150 ring-1 ring-black/[0.06] shadow-[0_20px_60px_rgba(0,0,0,0.25)] animate-modal-pop">
        <div className="px-7 pt-8 pb-6 text-center">
          <div className="mx-auto mb-5 w-20 h-20 rounded-[22px] bg-[#664bc7]/10 flex items-center justify-center">
            <img
              src={CBELogo}
              alt="CBE SuperApp"
              className="w-14 h-14 object-contain"
            />
          </div>
          <h1 className="text-[19px] font-semibold text-gray-900 tracking-tight">
            {title}
          </h1>
          <p className="mt-2 text-[14px] leading-relaxed text-gray-500">
            {message}
          </p>
        </div>
        <button
          onClick={onClose}
          className="w-full h-[54px] border-t border-black/[0.08] text-[18px] font-semibold text-[#664bc7] active:bg-black/5 transition-colors"
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
};

export default AlertModal;
